import loadable from '@loadable/component';

export const TheweekukSiteWrapper = loadable(
  () => import(/* webpackChunkName: "theweekuk-site" */ './TheweekukSiteWrapper'),
);
